<template>
  <div ref="container">
    <div :id="`embedded_${$route.params.name}_app`"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "show_embedded",
  data() {
    return {
      mounted: false
    };
  },
  mounted() {
    this.mount();
  },
  watch: {
    embedded() {
      this.mount();
    }
  },
  methods: {
    mount() {
      if (this.mounted) {
        return;
      }
      let embedded = this.embedded.filter(
        v => v.name === this.$route.params.name
      )[0];
      if (!embedded || !embedded.complete) {
        return;
      }
      this.$refs.container.appendChild(embedded.element);
      this.mounted = true;
    }
  },
  computed: {
    ...mapGetters({
      embedded: "embedded/embedded"
    })
  }
};
</script>

<style scoped></style>
